<template>
  <page>
    <!-- <v-flex xs12>
      <v-toolbar color="white" class="elevation-1" height="50">
        <v-tabs v-model="tabs">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab href="#users">Backend Users</v-tab>
          <v-tab href="#members">Members</v-tab>
        </v-tabs>
      </v-toolbar>
    </v-flex> -->
    <v-flex xs12>
      <!-- <v-tabs-items v-model="tabs">
        <v-tab-item value="users"> -->
          <v-layout row wrap>
            <v-flex xs12>
              <form>
                <v-expansion-panel expand :value="[true]">
                  <v-expansion-panel-content>
                    <div slot="header">
                      <v-icon>mdi-filter-variant</v-icon> Filters
                    </div>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.usrRefId" :label="filtersLabel.usrRefId" :error-messages="errors.collect('usrRefId')" data-vv-name="usrRefId" :data-vv-as="filtersLabel.usrRefId" v-validate="'entry|max:60'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.firstName" :label="filtersLabel.firstName" :error-messages="errors.collect('firstName')" data-vv-name="firstName" :data-vv-as="filtersLabel.firstName" v-validate="'name|max:60'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.lastName" :label="filtersLabel.lastName" :error-messages="errors.collect('lastName')" data-vv-name="lastName" :data-vv-as="filtersLabel.lastName" v-validate="'name|max:60'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.email" type="email" :label="filtersLabel.email" :error-messages="errors.collect('email')" data-vv-name="email" :data-vv-as="filtersLabel.email" v-validate="'email'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.mobileNo" v-int-mask="{intScale: 8}" type="tel" :label="filtersLabel.mobileNo" :error-messages="errors.collect('mobileNo')" data-vv-name="mobileNo" :data-vv-as="filtersLabel.mobileNo" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.officeNo" v-int-mask="{intScale: 8}" type="tel" :label="filtersLabel.officeNo" :error-messages="errors.collect('officeNo')" data-vv-name="officeNo" :data-vv-as="filtersLabel.officeNo" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="intermediaryList" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-int-mask="{intScale: 5}" v-model="filters.id" :label="filtersLabel.id" type="tel" :error-messages="errors.collect('id')" data-vv-name="id" :data-vv-as="filtersLabel.id" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </form>
            </v-flex>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title>
                  <div>
                    <div class="headline">Users Listing</div>
                  </div>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="userId" :loading="loading" :no-data-text="noDataText">
                  <template slot="headerCell" slot-scope="props">
                    <v-tooltip bottom>
                      <span slot="activator">
                        {{ props.header.text }}
                      </span>
                      <span>
                        {{ props.header.text }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.usrRefId }}</td>
                    <td class="text-xs-right">{{ props.item.firstName }}</td>
                    <td class="text-xs-right">{{ props.item.lastName }}</td>
                    <td class="text-xs-right">{{ props.item.email }}</td>
                    <td class="text-xs-right">{{ props.item.mobileNo }}</td>
                    <td class="text-xs-right">{{ props.item.officeNo }}</td>
                    <td class="text-xs-right">{{ props.item.intermediary }}</td>
                    <td class="text-xs-right">{{ formatBoolean(props.item.acctDisabled) }}</td>
                    <td class="text-xs-right">{{ formatDate(props.item.createdDate) }}</td>
                    <td class="text-xs-right">
                      <table-action :rowData="props" query :review="checkAccess(['userReview'])" @query="doQuery" @review="doReview"></table-action>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
              <div class="pt-2">
                <v-btn color="primary" @click="doNew">
                  Add New User
                  <v-icon right>mdi-account-plus</v-icon>
                </v-btn>
                <v-btn color="secondary" @click="doExportUserRoles">
                  Export User Roles
                  <v-icon right>mdi-file-export</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        <!-- </v-tab-item>
        <v-tab-item value="members" lazy>
          <members></members>
        </v-tab-item>
      </v-tabs-items> -->
    </v-flex>
  </page>
</template>

<script>
import toDate from 'date-fns/toDate'
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { ADMINUSER_INTERMEDIARY } from '@/store/types'
// import Members from './Members'

export default {
  data() {
    return {
      headers: [
        { text: 'Ref ID', align: 'left', value: 'usrRefId' },
        { text: 'First Name', align: 'right', value: 'firstName' },
        { text: 'last Name', align: 'right', value: 'lastName' },
        { text: 'Email', align: 'right', value: 'email' },
        { text: 'Mobile No.', align: 'right', value: 'mobileNo' },
        { text: 'Office/Ext No.', align: 'right', value: 'officeNo' },
        { text: 'Intermediary.', align: 'right', value: 'intermediary' },
        { text: 'Acct Disabled', align: 'right', value: 'acctDisabled', sortable: false },
        { text: 'Created Date', align: 'right', value: 'createdDate', sortable: false },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        usrRefId: null,
        id: null,
        firstName: null,
        lastName: null,
        email: null,
        mobileNo: null,
        officeNo: null,
        intermediary: null
      },
      filtersLabel: {
        usrRefId: 'Reference Id',
        id: 'User Id',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        mobileNo: 'Mobile No.',
        officeNo: 'Office No.',
        intermediary: 'Intermediary'
      },
      tabs: null
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    intermediaryList() {
      return this.$store.state.adminUser.intermediaryList
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.adminUser.menu.usersList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((user) => {
                const convertUser = {
                  id: user.userId,
                  usrRefId: user.usrRefId,
                  firstName: user.firstName,
                  lastName: user.lastName,
                  email: user.email,
                  mobileNo: user.mobileNo,
                  officeNo: user.officeNo,
                  acctDisabled: user.acctDisabled,
                  intermediary: user.intermediaryName,
                  createdDate: toDate(user.createdDate)
                }
                this.items.push(convertUser)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$store.commit(ADMINUSER_INTERMEDIARY, result.data.intermediaryList)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doQuery(data) {
      if (data && data.item && data.item.id) {
        this.$router.push({ name: 'userQuery', params: { id: data.item.id } })
      }
    },
    doReview(data) {
      if (data && data.item && data.item.id) {
        this.$router.push({ name: 'userReview', params: { id: data.item.id } })
      }
    },
    doNew() {
      this.$router.push({ name: 'userReview', params: { id: 'new' } })
    },
    doClearFilters() {
      this.filters.id = null
      this.filters.firstName = null
      this.filters.lastName = null
      this.filters.email = null
      this.filters.mobileNo = null
      this.filters.officeNo = null
      this.filters.intermediary = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    async doExportUserRoles() {
      const apiURI = this.$store.state.adminUser.menu.exportUsrRoles
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.get(apiURI)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  components: {
    // Members
  }
}
</script>

<style lang="scss">
</style>
